<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane name="LossLegalHousePlanSelect" label="选择房产">
        <template slot="label">
          <span>
            选择房产
            <el-badge :value="legal_house_obj.total" ></el-badge>
          </span>
        </template>
        <LossLegalHousePlanSelect v-if="activeName==='LossLegalHousePlanSelect'" :project_id="project_id" :year_month="year_month" @onAdd="handleAdd"/>
      </el-tab-pane>
      <el-tab-pane name="LegalHouseYearPlanTempExcel" label="诉讼房产">
        <template slot="label">
          <span>
            诉讼房产
            <el-badge :value="legal_house_obj.count" ></el-badge>
          </span>
        </template>
        <LegalHouseYearPlanTempExcel v-if="activeName==='LegalHouseYearPlanTempExcel'" :project_id="project_id" :year_month="year_month" @onAdd="handleAdd"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import LossLegalHousePlan from "./LossLegalHousePlan";
import LegalHousePlanTemp from "./LegalHousePlanTemp";
import LegalHousePlanTempExcel from "./LegalHousePlanTempExcel";
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";
import LegalHousePlan from "./LegalHousePlan";
import LegalHousePlanUnit from "./LegalHousePlanUnit";
import LossLegalHousePlanSelect from "./LossLegalHousePlanSelect";
import LegalHouseYearPlanTempExcel from "./LegalHouseYearPlanTempExcel";
export default {
  name: "YearLitigationLayout",
  inject:['where','reginWhere'],
  components: {
    LegalHouseYearPlanTempExcel,
    LossLegalHousePlanSelect,
    LegalHousePlanUnit, LegalHousePlan, LegalHousePlanTempExcel,LegalHousePlanTemp, LossLegalHousePlan},
  props: {
    project_id: {
      type: Number,
      default: 0,
    },
    year_month:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      activeName: "LossLegalHousePlanSelect",
      legal_house_obj: {
        total: 0,
        count: 0,
      },
    };
  },
  mounted() {
    this.handleAdd();
  },
  methods: {
    handleAdd(){
      const that = this;
      let where = {
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        year_month:that.year_month,
      }
      ButlerHttp.post("ProjectCollectionProceedingPlanHouse/getLegalHouseCount",where,res=>{
        console.log(res.data)
        that.legal_house_obj = res.data;
      })
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        // that.handleAdd();
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        // that.handleAdd();
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        // that.handleAdd();
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        // that.handleAdd();
      },500,that);
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/YearLitigationLayout.vue